// Default virtual file system structure for Pink Pixel OS
export const STORAGE_KEY = 'pp_virtual_filesystem'

export const DEFAULT_FILE_SYSTEM = {
  'C:\\Users\\PinkPixel': {
    type: 'folder',
    items: {
      'Desktop': { 
        type: 'folder', 
        icon: 'fas fa-desktop text-blue-400', 
        items: {
          'Browser.lnk': { type: 'shortcut', targetApp: 'browser', icon: 'fas fa-globe text-blue-400', size: '1 KB', modified: '2026-09-06', description: 'Launch Web Browser' },
          'Terminal.lnk': { type: 'shortcut', targetApp: 'terminal', icon: 'fas fa-terminal text-emerald-400', size: '1 KB', modified: '2026-09-06', description: 'Launch Terminal Shell' },
          'Catalog.lnk': { type: 'shortcut', targetApp: 'store', icon: 'fas fa-shopping-bag text-pink-400', size: '1 KB', modified: '2026-09-06', description: 'Launch Applications Catalog' },
          'Photos.lnk': { type: 'shortcut', targetApp: 'photos', icon: 'fas fa-images text-rose-400', size: '1 KB', modified: '2026-09-06', description: 'Launch Photo Viewer' },
          'Games.lnk': { type: 'shortcut', targetApp: 'games', icon: 'fas fa-gamepad text-purple-400', size: '1 KB', modified: '2026-09-06', description: 'Launch Game Center' },
          'Quick_Notes.txt': { type: 'file', targetApp: 'notepad', icon: 'fas fa-file-alt text-amber-400', size: '2 KB', modified: '2026-09-06', description: 'Desktop notes and reminders' }
        }
      },
      'Documents': { 
        type: 'folder', 
        icon: 'fas fa-folder text-blue-400', 
        items: {
          'Resume_PinkPixel_2025.pdf': { type: 'file', icon: 'fas fa-file-pdf text-red-400', size: '2.3 MB', modified: '2025-01-15' },
          'AI_Research_Notes.md': { type: 'file', icon: 'fas fa-file-alt text-gray-400', size: '48 KB', modified: '2025-01-10' },
          'MCP_Specification_Notes.txt': { type: 'file', icon: 'fas fa-file-alt text-gray-400', size: '15 KB', modified: '2024-12-20' },
          'Project_Ideas.md': { type: 'file', icon: 'fas fa-lightbulb text-yellow-400', size: '12 KB', modified: '2025-01-08' }
        }
      },
      'Projects': {
        type: 'folder',
        icon: 'fas fa-folder text-purple-400',
        items: {
          'AI_Tools': {
            type: 'folder',
            icon: 'fas fa-robot text-purple-400',
            items: {
              'MCPollinations': { type: 'file', icon: 'fas fa-magic text-pink-400', size: '~', modified: '2025-01-12', description: 'Multimodal AI generation server' },
              'mem0-MCP': { type: 'file', icon: 'fas fa-brain text-blue-400', size: '~', modified: '2025-01-10', description: 'Long-term memory for AI agents' },
              'TaskFlow-MCP': { type: 'file', icon: 'fas fa-tasks text-green-400', size: '~', modified: '2025-01-08', description: 'Task management for AI workflows' },
              'MindBridge-MCP': { type: 'file', icon: 'fas fa-bridge-circle-check text-orange-400', size: '~', modified: '2025-01-05', description: 'Multi-LLM orchestration server' },
              'Deep-Research-MCP': { type: 'file', icon: 'fas fa-search text-cyan-400', size: '~', modified: '2024-12-28', description: 'Comprehensive web research tool' },
              'Web-Scout-MCP': { type: 'file', icon: 'fas fa-globe text-green-400', size: '~', modified: '2024-12-25', description: 'Web search and content extraction' },
              'NPM-Helper-MCP': { type: 'file', icon: 'fab fa-npm text-red-400', size: '~', modified: '2024-12-20', description: 'Node.js package management assistant' },
              'Notification-MCP': { type: 'file', icon: 'fas fa-bell text-yellow-400', size: '~', modified: '2024-12-15', description: 'System notifications for AI' }
            }
          },
          'Web_Apps': {
            type: 'folder',
            icon: 'fas fa-globe text-blue-400',
            items: {
              'Promptzy': { type: 'file', icon: 'fas fa-clipboard text-pink-400', size: '~', modified: '2025-01-10', description: 'AI prompt management platform' },
              'Comeback_AI': { type: 'file', icon: 'fas fa-microphone text-purple-400', size: '~', modified: '2024-12-30', description: 'AI-powered comeback generator' },
              'What_Is_This': { type: 'file', icon: 'fas fa-eye text-cyan-400', size: '~', modified: '2024-12-20', description: 'AI object identification tool' },
              'Dreamscape_AI': { type: 'file', icon: 'fas fa-palette text-pink-400', size: '~', modified: '2024-12-15', description: 'AI art studio and generator' },
              'Cosmic_Quest': { type: 'file', icon: 'fas fa-rocket text-purple-400', size: '~', modified: '2024-11-30', description: 'Interactive sci-fi adventure game' },
              'Pink_Pixel_OS': { type: 'file', icon: 'fas fa-desktop text-pink-400', size: '~', modified: '2025-01-15', description: 'This very OS simulation!' }
            }
          },
          'Developer_Tools': {
            type: 'folder',
            icon: 'fas fa-tools text-orange-400',
            items: {
              'Bibble': { type: 'file', icon: 'fas fa-terminal text-green-400', size: '~', modified: '2025-01-08', description: 'CLI AI assistant with MCP support' },
              'DiffuGen': { type: 'file', icon: 'fas fa-image text-blue-400', size: '~', modified: '2024-12-25', description: 'Local Stable Diffusion toolkit' },
              'Prysm': { type: 'file', icon: 'fas fa-spider text-gray-400', size: '~', modified: '2024-12-20', description: 'Intelligent web scraping engine' },
              'ComfyUI_LLM_Enhancer': { type: 'file', icon: 'fas fa-magic text-purple-400', size: '~', modified: '2024-12-10', description: 'LLM prompt enhancer for ComfyUI' },
              'MCP_CLI': { type: 'file', icon: 'fas fa-terminal text-cyan-400', size: '~', modified: '2024-12-05', description: 'Command-line tools for MCP' }
            }
          }
        }
      },
      'Pictures': {
        type: 'folder',
        icon: 'fas fa-folder text-pink-400',
        items: {
          'Profile_Avatar_Pink.png': { type: 'file', icon: 'fas fa-image text-pink-400', size: '256 KB', modified: '2024-12-01' },
          'Project_Screenshots': { 
            type: 'folder', 
            icon: 'fas fa-camera text-blue-400',
            items: {
              'Promptzy_Dashboard.png': { type: 'file', icon: 'fas fa-image text-green-400', size: '1.2 MB', modified: '2024-12-30' },
              'Dreamscape_Gallery.png': { type: 'file', icon: 'fas fa-image text-purple-400', size: '2.1 MB', modified: '2024-12-25' },
              'Comeback_AI_Interface.png': { type: 'file', icon: 'fas fa-image text-orange-400', size: '890 KB', modified: '2024-12-20' }
            }
          },
          'Pixel_Art': {
            type: 'folder',
            icon: 'fas fa-paint-brush text-pink-400',
            items: {
              'Pink_Heart_16x16.png': { type: 'file', icon: 'fas fa-heart text-pink-400', size: '2 KB', modified: '2024-11-15' },
              'Spaceship_32x32.png': { type: 'file', icon: 'fas fa-rocket text-blue-400', size: '4 KB', modified: '2024-11-10' },
              'Unicorn_64x64.png': { type: 'file', icon: 'fas fa-unicorn text-purple-400', size: '8 KB', modified: '2024-11-05' }
            }
          }
        }
      },
      'Downloads': {
        type: 'folder',
        icon: 'fas fa-folder text-green-400',
        items: {
          'API_Documentation.pdf': { type: 'file', icon: 'fas fa-file-pdf text-red-400', size: '5.7 MB', modified: '2025-01-10' },
          'React_Cheat_Sheet.pdf': { type: 'file', icon: 'fas fa-file-pdf text-blue-400', size: '1.1 MB', modified: '2024-12-15' },
          'AI_Models_Comparison.xlsx': { type: 'file', icon: 'fas fa-file-excel text-green-400', size: '423 KB', modified: '2024-12-01' }
        }
      },
      'Music': {
        type: 'folder',
        icon: 'fas fa-folder text-purple-400',
        items: {
          'Coding_Playlist.m3u': { type: 'file', icon: 'fas fa-music text-purple-400', size: '2 KB', modified: '2024-12-20' },
          'Lo-Fi_Focus_Mix.mp3': { type: 'file', icon: 'fas fa-music text-blue-400', size: '45.2 MB', modified: '2024-12-15' },
          'Cyberpunk_Synthwave.mp3': { type: 'file', icon: 'fas fa-music text-pink-400', size: '38.7 MB', modified: '2024-12-10' }
        }
      }
    }
  }
}

export const loadFileSystem = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const parsed = JSON.parse(stored)
      if (parsed && parsed['C:\\Users\\PinkPixel']) {
        return parsed
      }
    }
  } catch (err) {
    console.warn('Failed to load virtual file system from localStorage:', err)
  }
  return JSON.parse(JSON.stringify(DEFAULT_FILE_SYSTEM))
}

export const saveFileSystem = (fs) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(fs))
  } catch (err) {
    console.warn('Failed to save virtual file system to localStorage:', err)
  }
}

export const resetFileSystem = () => {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (err) {
    console.warn('Failed to reset virtual file system:', err)
  }
  return JSON.parse(JSON.stringify(DEFAULT_FILE_SYSTEM))
}

export const getIconForFilename = (name) => {
  const lower = (name || '').toLowerCase()
  if (lower.endsWith('.txt') || lower.endsWith('.md')) return 'fas fa-file-alt text-amber-400'
  if (lower.endsWith('.pdf')) return 'fas fa-file-pdf text-red-400'
  if (lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.webp') || lower.endsWith('.gif')) {
    return 'fas fa-image text-pink-400'
  }
  if (lower.endsWith('.mp3') || lower.endsWith('.m3u') || lower.endsWith('.wav')) {
    return 'fas fa-music text-purple-400'
  }
  if (lower.endsWith('.js') || lower.endsWith('.jsx') || lower.endsWith('.ts') || lower.endsWith('.tsx')) {
    return 'fas fa-code text-cyan-400'
  }
  if (lower.endsWith('.lnk')) return 'fas fa-link text-blue-400'
  return 'fas fa-file text-gray-400'
}
